{
  "newAnnouncement": "新しいお知らせがあります",
  "notification": "通知とお知らせ",
  "unread": "未読の通知"
}
